import gsap from 'gsap';
import appStore from '../utils/state';
import isTailwindBreakpoint from '../utils/isTailwindBreakpoint';

export default class HeaderMainNav extends HTMLElement {
  private showTl: gsap.core.Timeline | null = null;
  private hideTl: gsap.core.Timeline | null = null;

  private isMobile = false;
  private isMainNavOpen = false;

  private unsubscribeFromMainNavToggle: (() => void) | null = null;

  private onMainNavToggleBound = this.onMainNavToggle.bind(this);
  private onResizeBound = this.onResize.bind(this);

  connectedCallback(): void {
    this.addEventListeners();
    this.subscribe();
  }

  addEventListeners(): void {
    window.addEventListener('resize', this.onResizeBound);
    this.onResize();
  }

  removeEventListeners(): void {
    window.removeEventListener('resize', this.onResizeBound);
  }

  subscribe(): void {
    this.unsubscribeFromMainNavToggle = appStore.subscribeKey('isMainNavOpen', this.onMainNavToggleBound);
  }

  unsubscribe(): void {
    if (this.unsubscribeFromMainNavToggle) {
      this.unsubscribeFromMainNavToggle();
      this.unsubscribeFromMainNavToggle = null;
    }
  }

  onResize(): void {
    this.isMobile = !isTailwindBreakpoint('lg');

    if (this.isMobile == false) {
      this.show(true);
    } else {
      if (this.isMainNavOpen) {
        this.show(true);
      } else {
        this.hide(true);
      }
    }
  }

  onMainNavToggle(): void {
    const isMainNavOpen = appStore.getState().isMainNavOpen;
    this.isMainNavOpen = isMainNavOpen;

    if (this.isMainNavOpen) {
      this.show();
    } else {
      this.hide();
    }
  }

  show(quick: boolean = false): void {
    if (this.hideTl) {
      this.hideTl.kill();
    }
    if (this.showTl) {
      this.showTl.kill();
    }

    this.showTl = gsap.timeline();

    if (quick) {
      this.showTl.set(this, { autoAlpha: 1, x: 0 }, 0);
    } else {
      if (this.isMobile) {
        this.showTl.fromTo(this, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3, ease: 'power2.out' }, 0);
        this.showTl.fromTo(this, { x: '-5%' }, { x: 0, force3D: true, duration: 0.7, ease: 'expo.out' }, 0);
      }
    }
  }

  hide(quick: boolean = false): void {
    if (this.showTl) {
      this.showTl.kill();
    }
    if (this.hideTl) {
      this.hideTl.kill();
    }
    this.hideTl = gsap.timeline();
    if (quick) {
      this.hideTl.set(this, { autoAlpha: 0, x: 0 }, 0);
    } else {
      if (this.isMobile) {
        this.hideTl.to(this, { autoAlpha: 0, duration: 0.15, ease: 'power2.out' }, 0);
        this.hideTl.to(this, { x: '-5%', duration: 0.3, force3D: true, ease: 'expo.out' }, 0);
      }
    }
  }

  disconnectedCallback(): void {
    this.unsubscribe();
    this.removeEventListeners();

    if (this.showTl) {
      this.showTl.kill();
    }
    if (this.hideTl) {
      this.hideTl.kill();
    }
  }
}

customElements.define('header-main-nav', HeaderMainNav);
